import { render, staticRenderFns } from "./lantern-section.vue?vue&type=template&id=358cec07&scoped=true&"
import script from "./lantern-section.vue?vue&type=script&lang=ts&"
export * from "./lantern-section.vue?vue&type=script&lang=ts&"
import style0 from "./lantern-section.vue?vue&type=style&index=0&id=358cec07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358cec07",
  null
  
)

export default component.exports